var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "doc-save-component", attrs: { "data-grm-comp": "Save" } },
    [
      _c("div", { staticClass: "doc-save" }, [
        _c(
          "div",
          { staticClass: "doc-save-header" },
          [
            _c("p", { staticClass: "doc-save-title" }, [
              _vm._v(_vm._s(_vm.$t("doc.save.download"))),
            ]),
            _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
          ],
          1
        ),
        _c("div", { staticClass: "doc-save-body" }, [
          _c("p", { staticClass: "doc-save-description" }, [
            _vm._v(_vm._s(_vm.$t("doc.save.select"))),
          ]),
          _c("ul", { staticClass: "doc-save-list" }, [
            _c("li", { staticClass: "doc-save-item" }, [
              _c(
                "button",
                {
                  staticClass: "doc-save-button original",
                  on: {
                    click: function ($event) {
                      return _vm.onSaveFile({ withDrawing: false })
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("doc.save.original")))]
              ),
            ]),
            _c("li", { staticClass: "doc-save-item" }, [
              _c(
                "button",
                {
                  staticClass: "doc-save-button with-drawing",
                  on: {
                    click: function ($event) {
                      return _vm.onSaveFile({ withDrawing: true })
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("doc.save.writing")))]
              ),
            ]),
          ]),
          _vm.download
            ? _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("doc.save.text")) +
                    " : " +
                    _vm._s(_vm.downloadPercent) +
                    "%"
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }